import { gorgiasPostQuery } from '../../api';
import { GORGIAS } from '../../constants/conversationTypes';
import { extractSelectedTicketFromState } from '../../extractFromState';

const createGorgiasTaggingPayload = (ticket, updatedTags) => {
  if (!ticket || ticket.ticketType !== GORGIAS) {
    throw new Error('Ticket not found, or it is a non-GORGIAS ticket');
  }
  const selectedTagsValues = updatedTags.map((updatedTag) => updatedTag.value);
  const payload = {
    accountDomain: ticket.platformDomain,
    ticketID: ticket.platformTicketId,
    conversationId: ticket.ticketId,
    tags: selectedTagsValues,
  };

  return payload;
};

export const updateGorgiasDummyTicketTags = (updatedTags) => {
  return async (dispatch, getState) => {
    const ticket = extractSelectedTicketFromState(getState());
    const payload = createGorgiasTaggingPayload(ticket, updatedTags);
    await gorgiasPostQuery('/setTicketDummyTags', payload);
  };
};
